if (!window.__hemiInit) {
  window.__hemiInit = true;
  document.documentElement.classList.add('hemi-js');
  (function () {
    var KEY = 'hemi-choice';
    function detect() {
      try {
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        if (/Australia|Pacific\/Auckland|Africa\/Johannesburg|America\/(Argentina|Sao_Paulo|Santiago)|Antarctica/i.test(tz)) return 'south';
      } catch (e) {}
      return 'north';
    }
    function current() { try { return localStorage.getItem(KEY) || detect(); } catch (e) { return detect(); } }
    function apply(h, user) {
      document.documentElement.setAttribute('data-hemi', h);
      var o = document.querySelectorAll('[data-hemi-opt]');
      for (var i = 0; i < o.length; i++) { o[i].classList.toggle('is-active', o[i].getAttribute('data-hemi-opt') === h); }
      document.dispatchEvent(new CustomEvent('hemi:change', { detail: { hemi: h, user: !!user } }));
    }
    function set(h) { try { localStorage.setItem(KEY, h); } catch (e) {} apply(h, true); }
    window.HemiToggle = { set: set, get: current };
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-hemi-opt]') : null;
      if (t) { e.preventDefault(); set(t.getAttribute('data-hemi-opt')); }
    });
    var io;
    function revealAll() { var e = document.querySelectorAll('.hemi-reveal'); for (var i = 0; i < e.length; i++) e[i].classList.add('in'); }
    function reveal() {
      var dm = window.Shopify && window.Shopify.designMode;
      if (dm || !('IntersectionObserver' in window)) { revealAll(); return; }
      io = io || new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { threshold: 0.1 });
      var els = document.querySelectorAll('.hemi-reveal:not(.in)');
      for (var j = 0; j < els.length; j++) io.observe(els[j]);
      setTimeout(revealAll, 1600);
    }
    function init() { apply(current(), false); reveal(); }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', function () { apply(current(), false); reveal(); });
  })();
}
